/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
(function (Drupal, $) {
	"use strict";

	function toggleAccordionExpanded(button) {
		if (button.attr("aria-expanded") === "true") {
			button.attr("aria-expanded", "false");
			button.siblings(".content").attr("aria-hidden", "true");
		} else {
			button.attr("aria-expanded", "true");
			button.siblings(".content").attr("aria-hidden", "false");
		}
	}

	function setAccordionRowContentMargin(button) {
		if (button.attr("aria-expanded") === "true") {
			button.siblings(".content").css("margin-top", 0);
			button.siblings(".content").slideDown();
		} else {
			var height = button.siblings(".content").innerHeight();
			button.siblings(".content").css("margin-top", -1 * height);
			setTimeout(function () {
				button.siblings(".content").hide();
			}, 500);
		}
	}

	function initAccordion(context) {
		$(".accordion-label", context).each(function () {
			setAccordionRowContentMargin($(this));
		});
		$(".accordion-item .content").hide();
	}

	function handleAccordion(context) {
		$(".accordion-label", context).on("click", function () {
			toggleAccordionExpanded($(this));
			setAccordionRowContentMargin($(this));
		});
	}

	function handleAccordionResize(context) {
		$(window).on("resize", function () {
			initAccordion(context);
		});
	}

	Drupal.behaviors.initAccordion = { attach: initAccordion };
	Drupal.behaviors.handleAccordion = { attach: handleAccordion };
	Drupal.behaviors.handleAccordionResize = { attach: handleAccordionResize };
})(Drupal, jQuery);
